/* import __COLOCATED_TEMPLATE__ from './runbook-selector.hbs'; */
/* RESPONSIBLE TEAM: team-fin-voice */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type AppService from 'embercom/services/app-service';
import type IntlService from 'ember-intl/services/intl';
import type { FinVoiceRunbook } from 'embercom/objects/ai-agent/fin-voice/fin-voice-runbook-options';
import {
  getRunbookOptions,
  FIN_VOICE_RUNBOOK_FEATURE_FLAGS,
} from 'embercom/objects/ai-agent/fin-voice/fin-voice-runbook-options';

interface Signature {
  Element: HTMLElement;
  Args: {
    selectedRunbook: FinVoiceRunbook;
    onChange: (runbook: FinVoiceRunbook) => void;
    filterPlaceholder?: string;
    isDisabled?: boolean;
  };
}

export default class RunbookSelector extends Component<Signature> {
  @service declare appService: AppService;
  @service declare intl: IntlService;

  get runbookGroupedOptions() {
    let includeToast = this.appService.app.canUseFinVoiceToastRunbooks;

    return getRunbookOptions(includeToast).map((group) => ({
      heading: group.heading ? this.intl.t(group.heading) : undefined,
      items: group.items
        .filter((option) => this.shouldIncludeRunbook(option.value))
        .map((option) => ({
          value: option.value,
          text: this.intl.t(option.text),
        })),
    }));
  }

  /**
   * Check if a runbook should be included based on feature flags
   * @param runbookValue - The runbook value to check
   * @returns true if the runbook should be included
   */
  shouldIncludeRunbook(runbookValue: FinVoiceRunbook): boolean {
    let featureFlag = FIN_VOICE_RUNBOOK_FEATURE_FLAGS[runbookValue];
    return featureFlag ? this.appService.app.canUseFeature(featureFlag) : true;
  }

  @action
  onRunbookChange(runbook: FinVoiceRunbook) {
    this.args.onChange(runbook);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Operator::Fin::Setup::Components::RunbookSelector': typeof RunbookSelector;
  }
}
